module.exports = __webpack_public_path__ + "h5/img/alipay.4d81d05a.png";